// Turning what a mechanic picks in the AI diagnosis modal into invoice-form
// lines. The invoice form IS the shop's estimate (an unpaid invoice), the same
// form the mechanic agent's "Use this" pre-fills. Pure functions, no I/O.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const sameText = (a, b) => String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();

const isDuplicate = (line, existing) =>
  existing.some((p) =>
    line.part_number
      ? sameText(p.part_number, line.part_number)
      : sameText(p.part_name, line.part_name)
  );

// Existing invoice lines first, new ones after; a line the invoice already
// has is skipped so re-opening the estimate never doubles anything up.
export const appendEstimateLines = (existingParts, lines) => {
  const out = [...existingParts];
  let nextId = Math.max(-1, ...existingParts.map((p) => Number(p.id) || 0)) + 1;
  lines.forEach((line) => {
    if (isDuplicate(line, out)) return;
    out.push({ ...line, id: nextId });
    nextId += 1;
  });
  return out;
};

export const partLine = (part, quantity) => ({
  part_name: part.part_name,
  part_number: part.part_number || '',
  quantity,
  unit_cost: part.estimated_cost || 0,
});

// NHTSA suggestions carry no price, so they land at $0 for the mechanic to
// price. A recall keeps its campaign number in the line name.
export const suggestionLine = (suggestion, kind) => {
  const title = (kind === 'maintenance' ? suggestion.maintenance : suggestion.repair)?.title || '';
  const reason = suggestion.reason || '';
  const name = reason.startsWith('Safety recall') ? `${reason.split(' — ')[0]} — ${title}` : title;
  return { part_name: name, part_number: '', quantity: 1, unit_cost: suggestion.average_cost || 0 };
};

export const diagnosisNote = (diagnosis) => {
  const d = new Date(diagnosis.created_at);
  const when = `${d.getDate()} ${MONTHS[d.getMonth()]}`;
  const top = [...(diagnosis.possible_causes || [])].sort(
    (a, b) => (b.probability || 0) - (a.probability || 0)
  )[0];
  return top ? `From AI diagnosis, ${when}: top cause — ${top.cause}.` : `From AI diagnosis, ${when}.`;
};
